import React, { Fragment } from "react"

import Tag from "../../design-system/blog-tag"
import FeatherIcon from "../../design-system/feather-icon"
import type { BlogTag } from "../../page-components/blog/types"
import * as styles from "./index.module.scss"

export interface BlogTagCollectionProps {
  tags: BlogTag[]
  withIcon?: boolean
}

const BlogTagCollection: React.FC<BlogTagCollectionProps> = ({
  tags,
  withIcon = false,
}) => {
  return (
    <div className={styles.container} data-testid="BlogTagCollection">
      {withIcon && <FeatherIcon size="medium" type="tag" />}
      {tags.map(({ name }) => (
        <Fragment key={name}>
          <Tag text={name} />
          {"  "}
        </Fragment>
      ))}
    </div>
  )
}

export default BlogTagCollection
